import { createAction } from "typesafe-actions";
import { OfflineModeAssignment } from "types";

export const setIsOnline = createAction("APP/SET_IS_ONLINE")<boolean>();
export const addCachedAssignment = createAction(
  "APP/ADD_CACHED_ASSIGNMENT",
)<OfflineModeAssignment>();
export const addCachedAssignments = createAction("APP/ADD_CACHED_ASSIGNMENTS")<
  OfflineModeAssignment[] | []
>();
export const deleteCachedAssignment = createAction(
  "APP/DELETE_CACHED_ASSIGNMENT",
)<string>();
export const deleteAllCachedAssignment = createAction(
  "APP/DELETE_ALL_CACHED_ASSIGNMENT",
)();
export const setSwStatus =
  createAction("APP/SET_SW_STATUS")<ServiceWorkerState>();
export const setDownloading = createAction("APP/SET_DOWNLOADING")<boolean>();
export const setStatus = createAction("APP/SET_STATUS")<string>();
export const setLoading = createAction("APP/SET_LOADING")<boolean>();
